export function useNotificationNavigation(router) {
  function hasNotificationNavigation(msg) {
    if (!msg?.linkType || msg.linkType === 'NONE') return false
    if (msg.linkType === 'APPROVAL') return true
    if (msg.webUrl || msg.webPath) return true
    const linkTypeRoutes = ['ORDER', 'APPROVAL', 'CUSTOMER', 'CONTRACT', 'SCHEDULE', 'TODO', 'FORM']
    return linkTypeRoutes.includes(msg.linkType)
  }

  function buildNotificationNavigationTarget(msg) {
    if (!msg?.linkType || msg.linkType === 'NONE') return null

    const linkTypeRoutes = {
      ORDER: '/order',
      APPROVAL: '/approval',
      CUSTOMER: '/customer',
      CONTRACT: '/contract',
      SCHEDULE: '/schedule',
      TODO: '/todo',
      FORM: '/form'
    }

    const basePath = msg.linkType === 'APPROVAL' ? linkTypeRoutes.APPROVAL : (msg.webPath || linkTypeRoutes[msg.linkType])
    if (!basePath) return null

    const query = {}
    if (msg.businessId) {
      query.id = msg.businessId
    }
    if (msg.linkType === 'APPROVAL' && msg.businessId) {
      Object.assign(query, { openDetail: 'true' })
      if (isReadonlyWorkflowNotification(msg)) {
        Object.assign(query, { readonly: 'true' })
      }
      const approvalTab = getWorkflowApprovalTab(msg)
      if (approvalTab) {
        Object.assign(query, { tab: approvalTab })
      }
    }
    if (msg.extraParams && typeof msg.extraParams === 'object') {
      Object.assign(query, msg.extraParams)
    }

    return { path: basePath, query }
  }

  function isReadonlyWorkflowNotification(msg) {
    return ['WORKFLOW_CC', 'WORKFLOW_APPROVAL_RESULT'].includes(msg?.bizType)
  }

  function getWorkflowApprovalTab(msg) {
    const tabRoutes = {
      WORKFLOW_CC: { tab: 'cc' },
      WORKFLOW_APPROVAL_RESULT: { tab: 'initiated' }
    }
    return tabRoutes[msg?.bizType]?.tab
  }

  function navigateNotification(msg) {
    if (!msg?.linkType || msg.linkType === 'NONE') return false

    if (msg.linkType === 'APPROVAL') {
      const target = buildNotificationNavigationTarget(msg)
      if (!target) return false
      router.push(buildNotificationNavigationTarget(msg))
      return true
    }

    if (msg.webUrl) {
      if (msg.webUrl.startsWith('http://') || msg.webUrl.startsWith('https://')) {
        window.open(msg.webUrl, msg.webNewWindow ? '_blank' : '_self')
      } else {
        router.push(msg.webUrl)
      }
      return true
    }

    const target = buildNotificationNavigationTarget(msg)
    if (!target) return false
    router.push(buildNotificationNavigationTarget(msg))
    return true
  }

  return {
    hasNotificationNavigation,
    buildNotificationNavigationTarget,
    navigateNotification,
    isReadonlyWorkflowNotification,
    getWorkflowApprovalTab
  }
}
